<template>
  <div class="page-module">
    <mt-popup v-model="moduleState.storyMenu" position="right" class="menu-main">
      <div class="story-menu">
        <p class="title elli" v-text="$store.state.storyName"
           :style="{backgroundColor: isStoryDetail? '#F0F0F0': '#fff'}"
        ></p>
        <div class="main" v-show="isStoryDetail">
          <div class="chapters">
            <ul class="inner">
              <li v-for="(chapter, $index) in chapterList" :key="chapter.id" class="item"
                  :class="{act: $index === selectIndex}" @click="jumpStory(chapter, $index)">
                <img :src="parrent.types[chapter.mode].modeIcon" alt="parrent.types[chapter.mode].name" class="mark">
                <p class="name elli" v-text="chapter.name"></p>
                <a href="javascript:;" class="edit-chapter" @click.stop="editChapter(chapter, $index)"></a>
              </li>
            </ul>
            <a href="javascript:;" class="add-chapter" @click="addChapter">添加新章节</a>
          </div>

          <ul class="btns">
            <li class="btn save" @click="save">
              <i class="fun-ico"></i>
              保存作品
            </li>
            <li class="btn seting" @click="isStoryDetail = false">
              <i class="fun-ico"></i>
              作品设置
            </li>
            <li class="btn preview" @click="release(1, 37)">
              <i class="fun-ico"></i>
              快速预览
            </li>
            <li class="btn publish" @click="release(0, 38)">
              <i class="fun-ico"></i>
              发布作品
            </li>
          </ul>
        </div>
        <div class="story-perfect" v-show="!isStoryDetail">
          <div class="upload-cover">
            <i class="upload-slogan">
              点击此处替换封面（建议960*540）
            </i>
            <div class="cover">
              <img :src="storyCover" alt="作品封面" crossorigin="*">
            </div>
            <input type="file" @click="getStoryVer" v-if="aBox()">
            <input type="file" @change="getFile" accept="image/png,image/jpeg" v-else>
          </div>
          <div class="change-story-info change-story-name">
            <input v-model.trim="storyName" v-on:input="textDetection" @focus="focusDispose($event, 'name')">
            <i class="edit-btn" @click="setFocus($event, 41)"></i>
          </div>
          <div class="change-story-info change-story-desc">
            <textarea v-model.trim="storyDesc" @focus="focusDispose($event, 'desc')"
                      placeholder="写个简介，介绍下你的作品~"></textarea>
            <i class="edit-btn" @click="setFocus($event, 42)"></i>
          </div>
          <ul class="options">
            <li class="item jump-ico" @click="openTag()">
              标签
            </li>
            <li class="item jump-ico" @click="openPage('//www.66rpg.com/monthly/t_21/801.shtml')">
              教程链接
            </li>
          </ul>
          <a href="javascript:;" @click="isStoryDetail = true" class="back-history">
            返回上一级
          </a>
        </div>
      </div>
    </mt-popup>

    <mt-popup v-model="chapter.edit" position="bottom" class="change-chapter">
      <div class="main">
        <ul class="options">
          <li class="change-name">
            章节名称
            <input type="text" v-model.trim="chapter.newName" maxlength="20">
          </li>
          <li class="change-media jump-ico elli" @click="changeMedia('bg', 46)">
            背景图
            <span class="name fr" v-text="getChapterMedia('bg')"></span>
          </li>
          <li class="change-media jump-ico elli" @click="changeMedia('bgm', 47)">
            背景音乐
            <span class="name fr" v-text="getChapterMedia('bgm')"></span>
          </li>
        </ul>

        <div class="btns">
          <a href="javascript:;" class="btn del" @click="chapterWidget('remove', 48)">删除本章</a>
          <a href="javascript:;" class="btn cancel" @click="chapterWidget('cancel', 49)">取消</a>
          <a href="javascript:;" class="btn affirm" @click="chapterWidget('confirm', 50)">确定</a>
        </div>
      </div>
    </mt-popup>

    <div class="loading-bg" v-if="publishLoading">
      <div class="loading">
        <mt-spinner type="double-bounce" color="#ff6600" v-if="aBoxCoverLoading"></mt-spinner>
        <template v-else>
          服务器连线中……
        </template>
      </div>
    </div>

    <malib-bg v-if="moduleState.imageLibrary"></malib-bg>

    <malib-music v-if="moduleState.musicLibrary"></malib-music>

    <publish-suc v-if="moduleState.issueSuccess" v-bind="{previewSrc}" @openStory="openPage(previewSrc, 'game')"></publish-suc>

    <open-link v-if="preview" v-bind:conf="{isOpen: preview, previewSrc, type: previewType}" @close="closePreview"></open-link>

    <edit-text v-bind="editTextConf"></edit-text>

    <add-tag></add-tag>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import addTag from '../components/add_tag';
  import {GameData} from '../store/GameData';
  import MalibBG from '../components/malib_bg';
  import openLink from '../components/open_link';
  import editText from '../components/edit_text';
  import {ProjectData} from '../store/ProjectData';
  import MalibMusic from '../components/malib_music';
  import publishSuc from '../components/issue_success';
  import {ComponentName, Methods, CdnLibrary} from '../const/common';

  var aBoxUpdateVer = null;
  export default {
    name: 'story_menu',
    components: {
      'add-tag': addTag,
      'malib-bg': MalibBG,
      'malib-music': MalibMusic,
      'publish-suc': publishSuc,
      'open-link': openLink,
      'edit-text': editText
    },
    store,
    Toast,
    data() {
      return {
        selectIndex: Middle.EditData.chapter,
        isLoading: false,
        projectData: new ProjectData(this),
        chapter: this.chapterDataInit(),
        isEditChapter: false,
        storyIndex: '',
        isStoryDetail: true,
        src: 'http://img1.vued.vanthink.cn/vued0a233185b6027244f9d43e653227439a.png',
        CommentMethods: Methods,
        storyName: store.state.storyName,
        storyDesc: Middle.ProjectData.header.description,
        preview: false,
        previewSrc: null,
        previewType: null,
        chapterBg: store.state.chapterConfig.bg,
        chapterBgm: store.state.chapterConfig.bgm,
        releasePmode: 1,
        editTextConf: {
          type: null
        },
        guid: Methods.getGuid(),
        token: window.orgUser.GetLoginToken(),
        updateCoverTimer: null,
        publishTimer: null
      }
    },
    computed: {
      watchCut() {
        return this.moduleState.editText
      },
      watchSlide() {
        return this.moduleState.musicLibrary
      },
      watchChapterEdit() {
        return this.chapter.edit
      },
      watchChapterName() {
        return this.chapter.newName;
      },
      ...mapState(['parrent', 'chapterList', 'moduleState', 'storyCover', 'chapterConfig', 'publishLoading', 'aBoxCoverLoading'])
    },
    methods: {
      openTag() {
        if (!Middle.ProjectData.header.gIndex || Middle.ProjectData.header.gIndex === '') {
          return Toast({
            message: '请发布作品后，再来打标签吧~'
          })
        }
        store.state.moduleState.addTag = true;
        Methods.checkChapterHash(43);
      },
      focusDispose(e, type) {
        e.target.blur();
        // this.changeFocus = true;
        this.editTextConf.type = type;
        Methods.cutComponent([ComponentName.EDIT_TEXT], true);
      },
      aBox() {
        var _res = false;

        if (window.org_box) {
          _res = true;
        }
        return _res;
      },
      getStoryVer() {
        var _this = this, actionUrl = CdnLibrary.request.ABOX_UPDATE_IMAGE;

        clearTimeout(this.updateCoverTimer);
        this.updateCoverTimer = setTimeout(function () {
          Methods.getUpdateVer(function (ver) {
            aBoxUpdateVer = ver;
            uploadCreate(() => {
              // 开始上传
            }, () => {
              // 上传弯沉
            }, () => {
              // 上传失败
            }, _this.guid, _this.token, actionUrl, 'outer', 2, aBoxUpdateVer)
          }, _this);
        }, 400)
        Methods.checkChapterHash(39);
      },
      closePreview() {
        this.preview = false;
      },
      getChapterMedia(type) {
        let _res = '';

        switch (type) {
          case 'bg':
            _res = (this.chapterConfig.bg && this.chapterConfig.bg.file_name) || this.chapter.bg || '修改章节的背景图';
            break;
          case 'bgm':
            _res = (this.chapterConfig.bgm && this.chapterConfig.bgm.name) || this.chapter.bgm || '修改章节的背景音乐';
            break;
        }
        return _res;
      },
      changeMedia(type, hash) {
        Methods.openMaLib(type === 'bg' ? ComponentName.IMAGE_LIBRARY : ComponentName.MUSIC_LIBRARY, 'set');
        store.state.changeChapterMedia = true;
        Methods.setHeaderConf('maLib', '返回', '');
        Methods.checkChapterHash(hash);
      },
      setFocus(e, hash) {
        e.target.previousElementSibling.focus();
        Methods.checkChapterHash(hash);
      },
      addChapter() {
        Methods.quietlySaveStory();
        Methods.addChapter(true, ComponentName.EDIT_STORY);
        Methods.checkChapterHash(34);
      },
      textDetection() {
        this.storyName = this.storyName.replace(store.state.nameReg, '').replace(store.state.emoReg, '');
      },
      getFile(e) {
        var reader = new FileReader(),
          file = e.target.files[0], _this = this;

        reader.addEventListener("load", function () {
          let name = file.name,
            maxSize = (file.size / 1024) / 1024;

          if (maxSize > 1) {
            return Toast({
              message: '图片体积太大，请重新选择。'
            });
          }

          var type = name.substring(name.length - 4, name.length);

          type = type.toLowerCase();
          if (type === '.png' || type === '.jpg' || type === 'jpeg') {
            Methods.uploadStoryCover.call(_this, file, null, reader);
          } else {
            return Toast({
              message: '只能用jpg、png格式的图片作为封面'
            });
          }
        }, false);

        if (file) {
          reader.readAsDataURL(file);
        }
        Methods.checkChapterHash(40);
      },
      chapterDataInit() {
        return {
          edit: false,
          name: '',
          index: '',
          newName: '',
          bg: null,
          bgm: null
        }
      },
      close() {
        Methods.cutComponent([ComponentName.STORY_MENU], false);
      },
      chapterWidget(type, hash) {
        var _index = this.chapter.index, _id = this.chapter.id;

        switch (type) {
          case 'remove':
            Methods.messageConfirm('提示', `是否删除章节--${this.chapter.name}`, '是', '否', function () {
              Methods.removeChapter(_index, _id);
            }, null);
            break;
          case 'confirm':
            if (this.chapter.newName.length < 2) {
              return Toast({
                message: '章节名太短。'
              });
            }
            Methods.changeChapterName(this.chapter.index, this.chapter.newName);

            let _conf = GameData.setChapterConfig(this.chapterConfig);

            if (_conf.bgm_name !== '') {
              Middle.MiddleData.SetBgm(_conf.bgm_name, this.chapter.id);
            }
            if (_conf.bg_name !== '') {
              Middle.MiddleData.SetBg(_conf.bg_name, this.chapter.id);
            }
            Middle.MiddleCommand.refreshBg();
            store.state.changeChapterMedia = false;
            break;
        }
        this.chapter = this.chapterDataInit();
        Methods.checkChapterHash(hash);
      },
      editChapter(chapter, i) {
        store.state.chapterConfig = {bg: null, bgm: null};
        this.chapter = {
          index: i,
          id: chapter.id,
          name: chapter.name,
          newName: chapter.name,
          bg: chapter.bg.replace('background/', ''),
          bgm: chapter.bgm.replace('bgm/', "").replace('BGM/', "").replace('.mp3', ''),
          edit: true
        };
        this.chapter.edit = true;
        Methods.checkChapterHash(33);
        return false;
      },
      jumpStory(chapter, index) {
        if (!(index === this.selectIndex)) {
          let _store = store.state;
          this.selectIndex = index;
          _store.editChapter = index;
          _store.parrent.createPattern = chapter.mode;
          _store.useRole = {charId: -1, cover: null, name: "", mood: 'normal'};
          _store.setRoleSiteDom = false;

          _store.visualEdit = false;
          _store.hideStoryInput = false;
          GameData.enterChapter(index);
        }
        this.close();
        Methods.checkChapterHash(32);
      },
      openPage(url, type) {
        this.previewType = type;
        this.previewSrc = url;
        this.preview = true;
        Methods.checkChapterHash(44);
      },
      setLoading(res) {
        store.state.publishLoading = res;
      },
      save() {
        this.setLoading(true);
        // CommentMethods.saveStory()
        this.projectData.saveStory(function (res) {
          this.setLoading(false);
          let _res = JSON.parse(res.target.response), _note = '';
          if (_res.ret === 1 && _res.code === 0) {
            _note = '保存成功';
          } else {
            _note = '保存失败';
          }
          Toast({
            message: _note
          });
        }, this);
        Methods.checkChapterHash(35);
      },
      release(pmode, hash) {
        this.setLoading(true);
        this.releasePmode = pmode;

        this.publishTimer = setTimeout(() => {
          Toast({
            message: '发布异常'
          });
          this.setLoading(false);
        }, 15000);

        this.projectData.saveStory(function () {
          StorageData.instance.delLocalData();
        }, this);
        Methods.uploadStoryCover.call(this, '', this.publish, null);
        Methods.checkChapterHash(hash);
      },
      publish() {
        var _that = this, releaseUrl, debugPath = '';
        setTimeout(() => {
          this.projectData.release(_that.releasePmode, function (data) {
            let time = new Date().getTime();
            let res = null, tips = null, gamePath = '', _token = orgUser.GetLoginToken(), _mark = '';
            try {
              res = JSON.parse(data.target.response);
              if (parseInt(res.ret) === 1) {
                if (res.game_url.indexOf('/debug/') > -1) {
                  debugPath = 'debug/'
                }
                if (window.org_box) {
                  _mark = 'android_light';
                } else if (window.iOSinfo) {
                  _mark = 'ios_light';
                } else {
                  _mark = 'light';
                }
                // _mark = "light"
                if (window.location.href.indexOf("test-") > -1) {
                  releaseUrl = `test-m.66rpg.com/h5/${debugPath}v2/`;
                } 
                else{
                  releaseUrl = `m.66rpg.com/h5/${debugPath}v2/`;
                }
                if (window.location.href.indexOf("test-") > -1) {
                  gamePath = `//${releaseUrl}${res.gindex}?time=${time}&testPath=true&quality=32&drddion=${_token}&mark=${_mark}`;
                } else {
                  gamePath = `//${releaseUrl}${res.gindex}?time=${time}quality=32&drddion=${_token}&mark=${_mark}`;
                }
                if (_that.releasePmode === 1) {
                  _that.openPage(gamePath, 'outer')
                } else {
                  _that.previewSrc = gamePath;
                  Middle.MiddleData.saveDescription(res.gindex)
                  Methods.cutComponent([ComponentName.ISSUS_SUCCESS], true);
                }
              } else if (parseInt(res.code) === 213) {
                tips = "未进行实名制认证，不能进行发布或预览。";
              } else {
                tips = "发布失败";
                if (parseInt(res.code) === 213) {
                  tips = "未进行实名制认证，不能进行发布或预览。";
                }
              }
            } catch (e) {
              tips = "发布失败";
              console.error(e);
            }
            clearTimeout(this.publishTimer);
            this.setLoading(false);
            if (tips) {
              Toast({
                message: tips
              });
            }
          }, this);
        }, 20)
      }
    },
    watch: {
      'isStoryDetail': function(newVal) {
        if (newVal) {
          Methods.checkChapterHash(36);
        } else {
          Methods.checkChapterHash(45);
        }
      },
      watchCut(newVal) {
        if (!newVal) {
          this.storyName = store.state.storyName;
          this.storyDesc = Middle.ProjectData.header.description;
        }
      },
      watchSlide(newVal) {
        if (!newVal) {
          Methods.multimediaReset();
        }
      },
      watchChapterEdit(newVal) {
        if (!newVal) {
          store.state.changeChapterMedia = false;
          store.state.chapterConfig = {
            bg: null,
            bgm: null
          }
        }
      },
      watchChapterName() {
        this.chapter.newName = this.chapter.newName.replace(store.state.emoReg, '');
      }
    }
  }

  window.androidCall = function (res) {
    var _res = JSON.parse(res);

    if (_res.ret === 1 && _res.code === 0) {
      var _store = store.state,
        coverUrl = location.protocol + CdnLibrary.PIC + '/orange/title/' + Methods.getGuid() + '_' + aBoxUpdateVer + '.jpg?v=' + Date.now();

      coverUrl = window.location.href.indexOf('test-') > -1 || window.location.href.indexOf('tool.') > -1 ? coverUrl.replace('orange', 'demo') : coverUrl;
      _store.publishLoading = _store.aBoxCoverLoading = true;
      setTimeout(function () {
        Middle.ProjectData.header.cover = _store.storyCover = coverUrl;
        _store.publishLoading = _store.aBoxCoverLoading = false;
      }, 3500)
    }
  }
</script>

<style scoped>
  @import "../style/css/story_menu.css";
</style>



// WEBPACK FOOTER //
// src/components/story_menu.vue